export default __webpack_public_path__ + "f1b5d200cfa3c495fa29a33d7b42a0f3.png";